/**
 * Redirect route for legacy "Visit Creator Portal" email links.
 *
 * Aspirex generates email links pointing to `/r/brand/{clientId}`.
 * This route authenticates the user, resolves their first organization,
 * and redirects to `/o/{orgSlug}/projects?brand={clientId}`.
 */
import { organizationListQueryOptions } from "@/lib/queries/organization";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/(app)/r/brand/$clientId")({
  beforeLoad: async ({ context, params }) => {
    const orgs = await context.queryClient.fetchQuery(
      organizationListQueryOptions(),
    );

    const orgSlug = orgs?.[0]?.slug;

    if (orgSlug) {
      throw redirect({
        to: "/o/$orgSlug/projects",
        params: { orgSlug },
        search: { brand: params.clientId },
      });
    }

    // No org found — fall back to home page
    throw redirect({ to: "/" });
  },
});
